import * as React from "react";
import Content from "../../../Content";

import Axios from "../../Components/Axios";
import moment from "moment";

import {withRouter} from "react-router";
import DataTable from "../../../DataTable";

const backendUrl = process.env.REACT_APP_BACKEND ?? '';

class ServiceLogs extends React.Component {

    defaultPath = '/admin/service_logs/';

    constructor(props) {
        super(props);
        let urlParams = new URLSearchParams(this.props.qs ?? '');

        this.state = {
            contentProviders: [],
            data: [],
            cp: urlParams.get('cp') ?? 0,
            periodFrom: urlParams.get('periodFrom') ?? moment().format("YYYY-MM-DD"),
            periodTo: urlParams.get('periodTo') ?? moment().format("YYYY-MM-DD"),
            periodType: "today",
            services: [],
            service: urlParams.get('service') ?? 0,
            types: {
                status: 'Изменение статуса',
                edit: 'Редактирование',
                add: 'Добавление'
            }
        };
    }

    getContentProviders() {
        Axios
            .get('api/kp/list')
            .then(r => this.setState({ contentProviders: r.data }))
            .catch(() => this.props.history.push('/'));
    }

    getServices() {
        Axios
            .get('api/services/list')
            .then(r => this.setState({ services: r.data }))
            .catch(() => this.props.history.push('/'));
    }

    getLog(params) {

        Axios
            .get('api/service_logs/list?' + (new URLSearchParams(params)).toString())
            .then(r => {
                this.setState({ list: r.data });
                this.state.dataTable.update(
                    r.data.map(v => {
                            v.service = this.state.services.find(x => +x.id === +v.serviceId)?.login ?? '';
                            v.logType = this.state.types[v.logType ?? 'z'] ?? '';

                            const cut = (v) => v.replace(/\.[^/.]+$/, '');

                            [ 'logoRu', 'logoKg', 'posterRu', 'posterKg' ].forEach( x =>
                                v[x] && (v[x] = `<a target="_blank" href = "${backendUrl}api/uploads/${cut(v[x] ?? '')}">${v[x]}</a>`)
                            );

                            v.status = v.status ? 'Включен' : 'Выключен';
                            v.smsAuth = v.smsAuth ? 'Включена' : 'Выключена';
                            v.kp = this.state.contentProviders.find(x => +x.id === +v.kpId)?.title ?? '';
                            v.date = moment(v.dateadd.date).format('YYYY-MM-DD HH:mm:ss');

                            return v;
                        }
                    )
                );
            })
            .catch(() => this.props.history.push('/'));

    }

    async handleSubmit(e) {
        e.preventDefault();
        if(this.state.periodType === "today") {
            await this.setState({
                periodFrom: moment().format("YYYY-MM-DD"),
                periodTo: moment().format("YYYY-MM-DD")
            });
        }

        const searchParams = (
            new URLSearchParams({
                periodFrom: this.state.periodFrom,
                periodTo: this.state.periodTo,
                cp: this.state.cp,
                service: this.state.service
            })
        ).toString();

        this.props.history.push(this.defaultPath + searchParams);

    }

    componentDidMount() {

        this.setState({
            dataTable: DataTable.init({ columns: [
                    'id','logType','service','titleRu','titleKg','logoRu','logoKg','posterRu','posterKg',
                    'priceRu', 'priceKg', 'status', 'smsAuth', 'kp', 'employe', 'login', 'apiUrl', 'tokenSalt',
                    'moreUrlRu', 'moreUrlKg', 'date'
                ] })
        });

        this.getContentProviders();
        this.getServices();
        this.loadData(this);

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(!!this.props.qs && this.props.qs !== prevProps.qs) {
            this.loadData(this);
        }
    }

    loadData(self) {
        let qs = this.props.match.params.params;
        let urlParams = new URLSearchParams(qs ?? '');

        let params = {
            cp: urlParams.get('cp') ?? 0,
            periodFrom: urlParams.get('periodFrom') ?? moment().format("YYYY-MM-DD"),
            periodTo: urlParams.get('periodTo') ?? moment().format("YYYY-MM-DD"),
            service: urlParams.get('service') ?? 0
        }

        if(
            params.periodTo !== moment().format("YYYY-MM-DD") ||
            params.periodFrom !== moment().format("YYYY-MM-DD")
        ) {
            this.setState({
                periodType: 'interval',
                periodFrom: params.periodFrom,
                periodTo: params.periodTo
            });
        }

        self.getLog(params);
    }

    handleChange(e, element) {
        this.setState({[element]: e.target.value});
    }

    render() {

        return (
            <Content title = "Логи сервисов">
                <h4 className="mb-3">Логи сервисов</h4>
                <form className="form-inline" onSubmit={e => this.handleSubmit(e, this)}>
                    <div className="form-group   mb-2 ">
                        <label className="sr-only">Контент-провайдер</label>
                        <select className="form-control" value = {this.state.cp} onChange={e => this.handleChange(e, 'cp')} >
                            <option value="0">По всем КП</option>
                            {
                                this.state.contentProviders.map(v => <option key={v.id} value={v.id}>{v.title}</option>)
                            }
                        </select>
                    </div>

                    <div className="form-group ml-4 mb-2 ">
                        <label className="sr-only">Услуга</label>
                        <select className="form-control" value = {this.state.service} onChange={e => this.handleChange(e, 'service')} >
                            <option value="0">По всем услугам</option>
                            {
                                this.state.services.map(v => <option key={v.id} value={v.id}>{v.titleRu}</option>)
                            }
                        </select>
                    </div>

                    <div className="form-group ml-4  mb-2 ">
                        <label htmlFor="staticEmail2" className="sr-only">Период</label>
                        <select className="form-control" name="period" id="period" value={this.state.periodType} onChange={e => this.handleChange(e, 'periodType')}>
                            <option value="today"> За сегодня</option>
                            <option value="interval"> За период</option>
                        </select>
                    </div>
                    {
                        this.state.periodType === "interval" &&
                        <>
                            <div className="form-group  ml-sm-4  mb-2 periods">
                                <label>Дата с
                                    <input
                                        className="form-control date ml-2"
                                        type="date"
                                        value={this.state.periodFrom}
                                        onChange={e => this.handleChange(e, 'periodFrom')}
                                    />
                                </label>
                                </div>
                            <div className="form-group  ml-sm-4  mb-2 periods">
                                <label>до
                                    <input
                                        className="form-control date ml-2"
                                        type="date"
                                        value={this.state.periodTo}
                                        onChange={e => this.handleChange(e, 'periodTo')}
                                    />
                                </label>
                            </div>
                        </>
                    }
                    <div className="form-group ml-sm-4 mb-2 mt-2">
                        <button type="submit" className="btn btn-primary mb-2">Показать отчет</button>
                    </div>
                </form>
                <div className="table-responsive">
                    <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                        <thead>
                        <tr>
                            <th>LOG_ID</th>
                            <th>Тип лога</th>
                            <th>Услуга</th>
                            <th>Заголовок RU</th>
                            <th>Заголовок KG</th>
                            <th>Логотип RU</th>
                            <th>Логотип KG</th>
                            <th>Баннер RU</th>
                            <th>Баннер KG</th>
                            <th>Стоимость RU</th>
                            <th>Стоимость KG</th>
                            <th>Статус услуги</th>
                            <th>SMS-авторизация</th>
                            <th>КП</th>
                            <th>Пользователь</th>
                            <th>Логин</th>
                            <th>API</th>
                            <th>Токен</th>
                            <th>Сайт услуги RU</th>
                            <th>Сайт услуги KG</th>
                            <th>Дата</th>
                        </tr>
                        </thead>
                        <tfoot>
                            <tr>
                                <th>LOG_ID</th>
                                <th>Тип лога</th>
                                <th>Услуга</th>
                                <th>Заголовок RU</th>
                                <th>Заголовок KG</th>
                                <th>Логотип RU</th>
                                <th>Логотип KG</th>
                                <th>Баннер RU</th>
                                <th>Баннер KG</th>
                                <th>Стоимость RU</th>
                                <th>Стоимость KG</th>
                                <th>Статус услуги</th>
                                <th>SMS-авторизация</th>
                                <th>КП</th>
                                <th>Пользователь</th>
                                <th>Логин</th>
                                <th>API</th>
                                <th>Токен</th>
                                <th>Сайт услуги RU</th>
                                <th>Сайт услуги KG</th>
                                <th>Дата</th>
                            </tr>
                        </tfoot>
                    </table>

                </div>
            </Content>
        );
    }

}

export default withRouter(ServiceLogs);